import { render, staticRenderFns } from "./createBid.vue?vue&type=template&id=3dd66c7f&"
import script from "./createBid.vue?vue&type=script&lang=js&"
export * from "./createBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./createBid.vue?vue&type=custom&index=0&blockType=strong"
if (typeof block0 === 'function') block0(component)

export default component.exports